/**
 * Logger utility that suppresses logs in production environment
 * Only shows logs in development or testing environments
 */

// Check if we're in production by looking at the NODE_ENV or a custom environment variable
const isProduction = process.env.NODE_ENV === 'production' && process.env.REACT_APP_ENVIRONMENT !== 'testing';

/**
 * Custom logger that suppresses logs in production
 */
const logger = {
  log: (...args: any[]) => {
    if (!isProduction) {
      console.log(...args);
    }
  },
  
  info: (...args: any[]) => {
    if (!isProduction) {
      console.info(...args);
    }
  },
  
  warn: (...args: any[]) => {
    if (!isProduction) {
      console.warn(...args);
    }
  },
  
  error: (...args: any[]) => {
    // Always log errors, even in production, as they're critical
    console.error(...args);
  },
  
  debug: (...args: any[]) => {
    if (!isProduction) {
      console.debug(...args);
    }
  }
};

export default logger;
